import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import Modal from '../modal';
import ConfirmationCodeInput from '../../inputs/confirmation-code-input/confirmation-code-input';
import './edit-email-modal.scss';
import useVerifyEmail from '../../../../utilities/hooks/useVerifyEmail';
import useAddresses from '../../../../utilities/hooks/useAddresses';
import useUpdateAddress from '../../../../utilities/hooks/useUpdateAddress';

const EditEmailModal = ({ emailToVerify, onClose }) => {
  const profile = useSelector((state) => state.accounts.user.profile);
  const addresses = useAddresses();

  const { verify: verifyEmail, isLoading: emailVerifing, error: verifyError } = useVerifyEmail();
  const { update: updateAddress, isLoading: addressUpdating } = useUpdateAddress();
  const [confirmationCode, setConfirmationCode] = useState(null);

  const handleEmailVerify = useCallback(() => {
    verifyEmail({
      firstName: profile.given_name,
      lastName: profile.family_name,
      email: emailToVerify,
      code: confirmationCode,
    }, {
      onSuccess: () => {
        const primaryAddress = addresses[0];
        updateAddress(primaryAddress.id, {
          ...primaryAddress,
          email: emailToVerify,
        }, {
          onSuccess: () => {
            onClose(true);
          },
        });
      },
    });
  }, [
    addresses,
    confirmationCode,
    emailToVerify,
    profile.family_name,
    profile.given_name,
    updateAddress,
    verifyEmail,
    onClose,
  ]);

  return (
    <Modal
      title="Verify email"
      submitText="Verify"
      cancelText="Cancel"
      maxWidth="440px"
      onSubmit={handleEmailVerify}
      onCancel={() => onClose()}
      submitting={emailVerifing || addressUpdating}
    >
      <div>
        We’ve sent a verification code to
        {' '}
        {emailToVerify}
        .
        Please enter the verification code to update your email.
      </div>
      <div className="edit-email-modal__code">
        <ConfirmationCodeInput
          defaultValue={confirmationCode}
          length={6}
          placeholder=" "
          onChange={setConfirmationCode}
          autoFocus
        />
        {verifyError ? (
          <div className="edit-email-modal__code__error">
            That verification code doesn’t quite look right.
            Verify the code is correct and try again.
          </div>
        ) : null}
      </div>
    </Modal>
  );
};

export default EditEmailModal;
